import {evite} from 'evite';
import * as reactDom from 'node-modules-react-dom';

Object.assign(exports, {reactDom});
evite.set(evite, 'exports.ReactDom', reactDom);

export default reactDom;
